var _path, _path2, _circle, _circle2, _rect, _circle3, _path3, _ellipse, _path4, _ellipse2, _path5, _path6, _path7, _circle4, _circle5, _path8, _ellipse3, _path9, _path10, _path11, _text, _text2, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternalVsExternal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 30 L200 230",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 185 Q78 108 110 95 Q142 108 142 185 Q110 198 78 185 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 60,
    width: 28,
    height: 20,
    rx: 4,
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 55,
    r: 4,
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70 L75 90",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 130,
    rx: 20,
    ry: 12,
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 127 L60 127 M55 133 L65 133",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 170,
    rx: 18,
    ry: 10,
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 168 L55 168 M38 174 L50 174",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63 170 L75 165",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258 185 Q258 108 290 95 Q322 108 322 185 Q290 198 258 185 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 138,
    r: 3,
    fill: "#fafcfb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275 115 Q280 108 285 115 Q290 108 295 115",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290,
    cy: 140,
    rx: 18,
    ry: 25,
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.35,
    strokeDasharray: "3 3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280 130 Q290 125 300 130 Q295 140 290 145 Q285 140 280 130",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M340 110 Q350 100 355 110 Q360 100 365 110",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M345 140 Q350 135 355 140",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 240,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.7
  }, "EXTERNAL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 258,
    y: 240,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.7
  }, "INTERNAL")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 50,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 50,
    r: 1.5,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 200,
    r: 1,
    fill: "#38bdf8",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 200,
    r: 1,
    fill: "#fbbf24",
    opacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 180,
    r: 2,
    fill: "#fafcfb",
    opacity: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 80,
    r: 2,
    fill: "#fafcfb",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalVsExternal);
export default __webpack_public_path__ + "static/media/internal-vs-external.861fbd05b9fa478c9aec77ed52e4553d.svg";
export { ForwardRef as ReactComponent };